<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>{{ $route.params.id < 0 ? "Tambah" : "Ubah" }} Gaji</h2>

      <div class="form-wrapper">
        <form @submit.prevent="save">
          <div class="form-group">
            <label>Bulan</label>
            <select v-model="data.bulan">
              <option value="01">Januari</option>
              <option value="02">Februari</option>
              <option value="03">Maret</option>
              <option value="04">April</option>
              <option value="05">Mei</option>
              <option value="06">Juni</option>
              <option value="07">Juli</option>
              <option value="08">Agustus</option>
              <option value="09">September</option>
              <option value="10">Oktober</option>
              <option value="11">November</option>
              <option value="12">Desember</option>
            </select>
          </div>
          <div class="form-group">
            <label>Jumlah Gaji</label>
            <input type="text" v-model="data.jumlah" />
          </div>

          <div class="form-group button">
            <button type="submit" class="btn-fill" :disabled="loading">
              Simpan
            </button>
            <button type="button" class="btn-outline" @click="back()">
              Kembali
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as api from "../../api/Api";

export default {
  name: "BahanBakuForm",
  components: {},
  data() {
    return {
      loading: false,
      data: {
        bulan: moment().format("MM"),
        jumlah: 0,
      },
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;
      api
        .get(
          "/v4/gaji?id=" +
            this.$route.params.id +
            "&id_toko=" +
            this.$toko.id
        )
        .then((r) => {
          this.loading = false;

          const bulanTahun = r.data.bulan_tahun.split("-");

          this.data.bulan = bulanTahun[0];
          this.data.tahun = bulanTahun[1];
          this.data.jumlah = r.data.jumlah_fix;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
    save() {
      if (!this.data.jumlah) {
        this.$toast("Jumlah gaji harus diisi");
        return;
      }

      this.loading = true;
      this.data.id = this.$route.params.id;
      this.data.id_toko = this.$toko.id;
      this.data.id_user = this.$user.id;
      this.data.bulan_tahun = this.data.bulan + "-" + moment().format("YYYY");

      api
        .post("/v4/gaji/save", this.data)
        .then((r) => {
          this.loading = false;

          if (r.valid) {
            this.$router.go(-1);
          } else {
            this.$toast(r.message);
          }
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal menyimpan data");
        });
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.loadData();
    }
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
  .form-wrapper {
    margin-top: 30px;
    form {
      width: 450px;
      .form-group.button {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 15px;
      }
      .autocomplete {
        position: relative;
        .autocomplete-option {
          position: absolute;
          background-color: #fff;
          border: 1px solid #ccc;
          box-shadow: 0px 2px 3px #ccc;
          border-radius: 5px;
          width: 100%;
          margin-top: 10px;
          ul {
            list-style-type: none;
            padding: 0;
            margin: 0;
            li {
              padding: 10px;
              font-size: 14px;
              border-bottom: 1px solid #ccc;
              &.active {
                background-color: var(--primary);
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  .btn-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;

    button {
      border: 0;
      padding: 12px;
      background: #fff;
      &.active {
        background: var(--light-blue);
      }
      &:first-child {
        border-radius: 6px 0 0 6px;
        &.active {
          border-right: 1px solid #ccc;
        }
      }
      &:last-child {
        border-radius: 0 6px 6px 0;
        &.active {
          border-left: 1px solid #ccc;
        }
      }
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .modal-body {
      background: #fff;
      padding: 15px;
      height: 130px;
      margin-top: 100px;
      border-radius: 10px;
      label {
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/transaksi/GajiKaryawanForm.vue